<template>
  <div class="premium-plan">
    <section class="unlimited-premium-border">
    </section>
    <section class="unlimited-premium-card">
      <div class="unlimited-premium-card__photo"><img v-bind:src="require('../../../static/img/premium_purchase_icon_1.png')" alt="辞書機能" width="100"></div>
      <section class="unlimited-premium-card__body unlimited-premium-card-body">
        <h2 class="unlimited-premium-card-body__ttl">辞書機能</h2>
        <p class="unlimited-premium-card-body__text">人気辞書が使い放題。MY単語の意味・例文の自動補完も可能。</p>
      </section>
    </section>
    <section class="unlimited-premium-border">
    </section>
    <section class="unlimited-premium-card">
      <div class="unlimited-premium-card__photo"><img v-bind:src="require('../../../static/img/premium_purchase_icon_2.png')" alt="MY単語機能" width="100"></div>
      <section class="unlimited-premium-card__body unlimited-premium-card-body">
        <h2 class="unlimited-premium-card-body__ttl">MY単語機能</h2>
        <p class="unlimited-premium-card-body__text">復習したい単語をMY単語帳に追加可能。MY単語はクイズ機能で復習もできます。</p>
      </section>
    </section>
    <section class="unlimited-premium-border">
    </section>
    <section class="unlimited-premium-card">
      <div class="unlimited-premium-card__photo"><img v-bind:src="require('../../../static/img/premium_purchase_icon_3.png')" alt="シャドーイング機能" width="100"></div>
      <section class="unlimited-premium-card__body unlimited-premium-card-body">
        <h2 class="unlimited-premium-card-body__ttl">シャドーイング・ディクテーション</h2>
        <p class="unlimited-premium-card-body__text">教材の音声を使ったシャドーイング・ディクテーションが利用可能に。</p>
      </section>
    </section>
    <section class="unlimited-premium-border">
    </section>
    <section class="unlimited-premium-card">
      <div class="unlimited-premium-card__photo"><img v-bind:src="require('../../../static/img/premium_purchase_icon_4.png')" alt="MyBooks登録無制限" width="100"></div>
      <section class="unlimited-premium-card__body unlimited-premium-card-body">
        <h2 class="unlimited-premium-card-body__ttl">MyBooks登録無制限</h2>
        <p class="unlimited-premium-card-body__text">お気に入りの教材をMyBooksへ無制限に登録可能に。</p>
      </section>
    </section>
    <section class="unlimited-premium-border">
    </section>
    <section class="unlimited-premium-card">
      <div class="unlimited-premium-card__photo"><img v-bind:src="require('../../../static/img/premium_purchase_icon_6.png')" alt="学習時間分析" width="100"></div>
      <section class="unlimited-premium-card__body unlimited-premium-card-body">
        <h2 class="unlimited-premium-card-body__ttl">学習時間分析</h2>
        <p class="unlimited-premium-card-body__text">教材の学習時間を全期間一元管理可能に。記録機能でアプリ以外の学習記録も可能です、</p>
      </section>
    </section>
  </div>
</template>

<script>
  import $ from 'jquery';

  export default {
    title: 'プレミアム機能詳細',
    headerTitle: 'プレミアム機能詳細',
    headerType: 'historyBack',
    resetScrollView: true,
    components: {
    },
    data() {
      return {
      }
    },
    mounted() {
    }
  }
</script>

<style scoped lang="scss">
.unlimited-premium-border {
  height: 10px;
  background-color: #f1f1f1;
}
.premium-plan {
  background-color: #fff;
  width: 800px;
  margin: 0 auto;
  @media screen and (max-width: 768px){
    width: auto;
  }
}

.unlimited-premium-card {
  border-radius: 5px;
  margin: 0 10px 10px 0;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px){
  }
  &:last-child {
    margin-bottom: 0;
  }
  &__photo {
    width: 120px;
    text-align: center;
    @media screen and (max-width: 768px){
      width: 100px;
      img {
        width: 70px;
        &.is-small {
          width: 56px;
        }
      }
    }
  }
  &__body {
    width: calc(100% - 130px);
    @media screen and (max-width: 768px){
      width: calc(100% - 105px);
    }
    text-align: justify;
  }
}

.unlimited-premium-card-body {
  line-height: 1.5;
  @media screen and (max-width: 768px){
    line-height: 1.35;
  }
  &__ttl {
    font-weight: bold;
    font-size: 16px;
    margin: 0 0 5px;
    @media screen and (max-width: 768px){
      font-size: 16px;
    }
  }
  &__text {
    font-size: 16px;
  }
  &__caption {
    color: #939293;
    font-size: 14px;
    @media screen and (max-width: 768px){
      font-size: 12px;
    }
    padding-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/campainPage/PremiumPlan.vue